import React, { Fragment } from 'react'
import { Helmet } from 'react-helmet'
import Header from '../Header'
import Footer from '../Footer'

import './reset.scss'
import '../../core/styles/defaults.scss'

class Layout extends React.Component {
  render() {
    const { children, title } = this.props

    return (
      <Fragment>
        <div id="scroll-wrapper">
          <Helmet>
            <title>{title}</title>
            <link href='https://api.mapbox.com/mapbox-gl-js/v0.53.0/mapbox-gl.css' rel='stylesheet' />
          </Helmet>
          
          <Header />
          <main>
            {children}
          </main>
          <Footer />
        </div>
      </Fragment>
    )
  }
}

export default Layout
